<ion-header>
    <ion-toolbar> 
        <ion-title>Accessories</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list>
        <ion-item *ngFor="let acc of tempList">
            <ion-label>
                <p>{{acc.item.description}}</p>
                <p>{{acc.item.stat}}</p>
            </ion-label>
            <ion-checkbox slot="end" checked="acc.ischecked" [(ngModel)]="acc.isChecked"></ion-checkbox>
        </ion-item>
    </ion-list>

    <ion-fab vertical="bottom" horizontal="center" slot="fixed">
        <ion-fab-button (click)="saveAccessories()" color="success">
            <ion-icon name="checkmark"></ion-icon>
        </ion-fab-button>
    </ion-fab>

</ion-content>
